intra_module.factory('Informations', function($resource, api_url, hub_api_url) {
    const url    = `${api_url}/students/:login/informations`;
    const params = [];
    const actions = {
        query: {
            method:  'GET',
            isArray: true
        },

        queryAll: {
            url:     `${url}/archived`,
            method:  'GET',
            isArray: true
        },

        validate: {
            method: 'POST',
            url:    `${hub_api_url}/notifications/archive`,
            params: []
        }
    };

    return $resource(url, params, actions);
});
